import { FormGroup, Switch } from "@blueprintjs/core";
import { MDBCol } from "mdbreact";
import { observer } from "mobx-react";
import * as React from "react";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ptBR } from '@mui/x-date-pickers/locales';
import dayjs from "dayjs";
import IntlCurrencyInput from "react-intl-currency-input";
import { toast } from "react-toastify";
import { observable } from "mobx";
import InfoModal from "../info-modal/InfoModal";
import { AppIcon } from "../utils/AppIcon";

interface State {
  cfop_calculo_sped: boolean
}

@observer
export default class EmpresaSped extends React.Component<{}, State> {

  obs = observable({
    open_ajuda: false as boolean,
  })

  constructor(props) {
    super(props);

    this.state = {
      cfop_calculo_sped: false
    }
  }

  handleChange = (e) => {
    const newValue = e.target.checked;
    this.setState({ cfop_calculo_sped: newValue })
    EmpresaStore.obs.empresa_edit.cfop_calculo_sped = newValue;
  };

  hanldeRendimento = (event, value) => {

    EmpresaStore.obs.empresa_edit.sped_valor_inicial = value

  }

  handleDataChange = (value) => {

    const data = value && value.$d ? value.$d : ""

    EmpresaStore.obs.empresa_edit.sped_valor_inicial_data = data

    if (!data || data == "Data inválida") return

    const dataSelecionada = new Date(value.$d);
    const hoje = new Date();

    const primeiroDiaMesAtual = new Date(hoje.getFullYear(), hoje.getMonth(), 1);

    if (dataSelecionada < primeiroDiaMesAtual) {

      EmpresaStore.obs.empresa_edit.sped_valor_inicial_data = data

    } else {

      toast.warn("Data inválida! Selecione uma data anterior ao mês atual.", {});

      EmpresaStore.obs.empresa_edit.sped_valor_inicial_data = ""

    }

  }

  formatDate(date) {

    if (!date) return null

    return dayjs(date).add(3, "hours")

  }

  maxDate() {

    const hoje = new Date();

    const ultimoDiaMesAnterior = new Date(hoje.getFullYear(), hoje.getMonth(), 0);

    return dayjs(ultimoDiaMesAnterior.toISOString().split('T')[0]);

  }

  render() {

    const currencyConfig = {
      locale: "pt-BR",
      formats: {
        number: {
          BRL: {
            style: "decimal",
            currency: "BRL",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          },
        },
      },
    };

    return (

      <>
        <MDBCol>

          <div style={{ width: 1000 }}>

            <FormGroup label="Data do saldo credor anterior" labelInfo={<>
              (Apuração) &nbsp;
              <AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer" }} onClick={() => this.obs.open_ajuda = true} />
            </>
            }>
              <LocalizationProvider
                localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                adapterLocale={"pt-br"}
                dateAdapter={AdapterDayjs}>
                <DatePicker maxDate={this.maxDate()} className="input-data-apuracao" views={['month', 'year']} onChange={(value) => this.handleDataChange(value)} value={this.formatDate(EmpresaStore.obs.empresa_edit.sped_valor_inicial_data)} format="MM/YYYY" slotProps={{ textField: { size: 'small' } }} />
              </LocalizationProvider>
            </FormGroup>

            <FormGroup label="Saldo credor anterior" labelInfo="(Apuração)">
              <IntlCurrencyInput
                className="form-control"
                onChange={this.hanldeRendimento}
                value={EmpresaStore.obs.empresa_edit.sped_valor_inicial}
                currency="BRL"
                config={currencyConfig}
              />
            </FormGroup>

            <FormGroup label="Cálculo Automático">
              <Switch
                className="select-regras"
                label={EmpresaStore.obs.empresa_edit.cfop_calculo_sped ? "Ativado" : "Desativado"}
                checked={EmpresaStore.obs.empresa_edit.cfop_calculo_sped}
                onChange={(e: any) => this.handleChange(e)} />
            </FormGroup>

          </div>

        </MDBCol>

        <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={"A data do saldo credor anterior deve coincidir com a data da apuração. Por exemplo, se você está apurando o mês de 02/2025, a data informada também deve ser 02/2025."} />

      </>

    );

  }

}
